import Upload from 'assets/images/icons/Upload.svg?react';
import { Loader2Icon } from 'components/icons';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';

interface BankTransferUploadBoxProps {
    isLoading: boolean;
}

const BankTransferUploadBox = ({ isLoading }: BankTransferUploadBoxProps) => {
    return (
        <div
            className={cn(
                'bg-grey-100 border-grey-300 rounded-[4px] border border-dashed px-16 py-6',
                isLoading ? 'cursor-default' : 'cursor-pointer'
            )}
        >
            <div className={cn('flex flex-col items-center', isLoading && 'text-fg-secondary')}>
                <p className="text-body1">
                    <FormattedMessage id={isLoading ? 'bank-transfers.uploading' : 'bank-transfers.drag-or-browse'} />
                </p>
                <div className="flex h-[17px] items-center justify-center">
                    {isLoading ? (
                        <Loader2Icon className="size-[17px] animate-spin" />
                    ) : (
                        <Upload className="new:text-foreground-secondary text-[#2A343D]" />
                    )}
                </div>
            </div>
        </div>
    );
};

export default BankTransferUploadBox;
